import React, {useState} from "react";
import "../../../../../../index.css";
import { Grid, Box} from "@mui/material";
import ContentWrapper from '../../../../../../common/components/ContentWrapper';
import CustomStepper from '../../../../../../common/components/CustomStepper';
import { useNavigate } from "react-router-dom";
import OwnersInfo from './OwnersInfo';
import PropertyInfo from './PropertyInfo';
import Documents from './Documents';
import PropertyInsurance from './PropertyInsurance';
import TitleCompany from "./TitleCompany";
import PropertyFinancing from "./PropertyFinancing";

const MainLayout = () => {
    const navigate = useNavigate();

    const [activeStep, setActiveStep] = useState(0);
    const [skipped, setSkipped] = useState(new Set());

    const isStepOptional = (step) => {
      return step === 1;
    };

    const isStepSkipped = (step) => {
      return skipped.has(step);
    };

    const handleNext = () => {
      let newSkipped = skipped;
      if (isStepSkipped(activeStep)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
      }

      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped);
    };

    const handleBack = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      console.log('e', activeStep)
    };

    const handleSkip = () => {
      if (!isStepOptional(activeStep)) {
        // You probably want to guard against something like this,
        // it should never occur unless someone's actively trying to break something.
        throw new Error("You can't skip a step that isn't optional.");
      }

      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped((prevSkipped) => {
        const newSkipped = new Set(prevSkipped.values());
        newSkipped.add(activeStep);
        return newSkipped;
      });
    };

    const handleReset = () => {
      setActiveStep(0);
    };

    const onCancelClick = () => {
      navigate(-1); // Navigate back one step in the history
    };

    const onBackOrCancelClick = () => {
      if(activeStep === 0 ){
        onCancelClick();
        window.localStorage.removeItem('selectedProperty');
        window.localStorage.removeItem('hideEdit');
      } else {
        handleBack();
      }
    }

    const steps = [{
      label: "Owner's Info",
      component: <OwnersInfo onBackOrCancelClick={onBackOrCancelClick} handleNext={handleNext}/>
    },
    {
      label: "Property Info",
      component: <PropertyInfo onBackOrCancelClick={onBackOrCancelClick} handleNext={handleNext}/>
    },
    {
      label: "My Property Financing",
      component: <PropertyFinancing onBackOrCancelClick={onBackOrCancelClick} handleNext={handleNext}/>
    },
    {
      label: "Documents",
      component: <Documents onBackOrCancelClick={onBackOrCancelClick} handleNext={handleNext}/>
    },
    {
      label: "My Property Insurance",
      component: <PropertyInsurance onBackOrCancelClick={onBackOrCancelClick} handleNext={handleNext}/>
    },
    {
      label: "My Title Company",
      component: <TitleCompany onBackOrCancelClick={onBackOrCancelClick} handleNext={handleNext}/>
    }
  ];
  return (
    <Grid container>
      {/* <Grid item xs={1} md={1} lg={1}></Grid> */}
      <div className=" my-property-container my-property-margin">
      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        className="box-container"
        style={{padding: 0}}
      >
        <Box sx={{ width: '100%'}}>
          <CustomStepper
           steps={steps} 
           activeStep={activeStep}  
           />
        </Box>
        
      </Grid>
      </div>
      {/* <Grid item xs={1} md={1} lg={1}></Grid> */}
    </Grid>
  );
};

const AddMyPropertyDetails = () => {
    return (
      <ContentWrapper title={"MY PROPERTY INVENTORY"} goback={false} img={false} contenview={<MainLayout />} />
    )
  }

export default AddMyPropertyDetails;